// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeUndefineds = (obj: any) => {
  Object.entries(obj).forEach(([key, val]) => {
    if (val && typeof val === "object") removeUndefineds(val);
    else if (val === null || val === undefined) delete obj[key];
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function removeUndefinedAndNull<T extends Record<string, any>>(
  obj: T
): T {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([_, value]) => value !== undefined && value !== null)
      .map(([key, value]) => [
        key,
        value && typeof value === "object" && !Array.isArray(value)
          ? removeUndefinedAndNull(value)
          : value,
      ])
  ) as T;
}

/**
 * Strips undefined but keeps null.
 *
 * On the settings payload a null is a value, not an absence: it is how the
 * form says "clear this mapping". The update that lands on Firestore is a
 * partial merge, so a stripped key leaves the old number in place and the
 * cleared mapping reappears on the next load.
 */
export function removeUndefinedDeep<T extends Record<string, any>>(
  obj: T
): T {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([_, value]) => value !== undefined)
      .map(([key, value]) => [
        key,
        value && typeof value === "object" && !Array.isArray(value)
          ? removeUndefinedDeep(value)
          : value,
      ])
  ) as T;
}
